import React, { useRef } from "react";
import { Button, Modal, Form as BTForm } from "react-bootstrap";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import FormInputText from "src/components/Forms/FormInputText";
import MultiLanguageInputText from "src/components/Forms/MultiLanguageInputText";
import moment from "moment";

const EditSeasonDialog = ({
  show,
  toggle,
  season = {},
  handleSuccess = null,
}) => {
  function validate(values) {
    const errors = {};

    if (!values.name && !values.name_it && !values.name_en) {
      errors.name =
        "Es muss für mindestens eine Sprache ein Name gesetzt sein.";
      errors.name_it =
        "Es muss für mindestens eine Sprache ein Name gesetzt sein.";
      errors.name_en =
        "Es muss für mindestens eine Sprache ein Name gesetzt sein.";
    }

    if (!values.from) {
      errors.from = "Startdatum darf nicht leer sein.";
    }

    if (!values.to) {
      errors.to = "Enddatum darf nicht leer sein.";
    }

    return errors;
  }

  function submit(values, { setSubmitting, setErrors }) {
    setSubmitting(true);
    let request;

    if (season.id) {
      request = axios.put(`/api/v1/seasons/${season.id}.json`, {
        season: values,
      });
    } else {
      request = axios.post(`/api/v1/seasons.json`, {
        season: values,
      });
    }

    request
      .then(function () {
        toggle();
        handleSuccess();
      })
      .catch(function (e) {
        setErrors(e.response.data);
      });
  }

  const formRef = useRef();

  const handleSubmit = () => {
    formRef.current.handleSubmit();
  };

  return (
    <Modal show={show} onHide={toggle}>
      <Modal.Header>
        <Modal.Title>{!season.id ? "Erstellen" : "Bearbeiten"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{
            name: season.name ?? "",
            name_it: season.name_it ?? "",
            name_en: season.name_en ?? "",
            from: moment(season.from).format(moment.HTML5_FMT.DATE) ?? "",
            to: moment(season.to).format(moment.HTML5_FMT.DATE) ?? "",
          }}
          validate={validate}
          onSubmit={submit}
        >
          {() => (
            <Form autoComplete="false">
              <MultiLanguageInputText
                label="Name"
                name="name"
                languages={["de", "it", "en"]}
              />
              <FormInputText label="Von" name="from" type="date" />
              <FormInputText label="Bis" name="to" type="date" />
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Schließen
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditSeasonDialog;
